import { useTranslation } from 'react-i18next';
import Tables from '../../components/InvoicesBrowseTable';

export default function Invoices() {
  const { t: tCI } = useTranslation([], {
    keyPrefix: 'team.Components.InvoiceBrowseTable',
  });
  return (
    <>
      <div className="flex flex-col justify-center mx-10 my-12 border border-gray-200 border-solid rounded shadow-xl md:mx-20 flex-1">
        <h2 className="pt-4 pl-4 pr-4 text-blue-600">
          {tCI('Browse Invoices')}
        </h2>
        <hr className="mx-5" />
        <Tables />
      </div>
    </>
  );
}
